var getLockedFields = function getLockedFields(allFields) {
  return allFields.filter(function (f) {
    return f.lock;
  }).map(function (f) {
    return f.id;
  });
};

export { getLockedFields };
//# sourceMappingURL=get-locked-fields.esm.js.map
